<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">


          <el-form-item label="产品名称" prop="name">
            <el-input size="small" style="width: 200px;" v-model="formInline.name" placeholder="产品名称"></el-input>
          </el-form-item>

          <el-form-item label="产品系列" prop="seriesId">
            <el-select v-model="formInline.seriesId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList(1)" >搜索</el-button>
            <el-button size="small" type="primary" @click="handleEdit()" >添加</el-button>
            <el-button size="small" type="danger" @click="handlePlDel" >批量删除</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" ref="tabs" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;"
                  :row-key="(row) => { return row.id }"  @selection-change="handleSelectionChangeDel">


          <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column prop="id" label="id" align="center"></el-table-column>
          <el-table-column prop="name" label="产品名称" align="center"></el-table-column>

          <el-table-column prop="coverImg" label="产品封面图" align="center" >
            <template slot-scope="scope">
              <div v-if="scope.row.coverImg != null && scope.row.coverImg != ''">
                <el-popover placement="top-start" trigger="hover">
                  <a :href="scope.row.coverImg" target="_blank" title="查看最大化图片"><img :src="scope.row.coverImg" style="width: 300px;height: 300px" /></a>
                  <img slot="reference" :src="scope.row.coverImg" style="width: 100px;height: 100px; cursor:pointer" />
                </el-popover>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="seriesId" label="产品系列" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.seriesId | getCate }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="sort" label="排序" align="center"></el-table-column>

          <el-table-column align="center"  prop="createTime" label="创建时间" >
            <template slot-scope="scope">
              <div>{{scope.row.createTime|timestampToTime}}</div>
            </template>
          </el-table-column>

          <el-table-column  label="操作" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="handleEdit(scope.row)"style="width: 100px;margin: 1px;">编辑</el-button>
              <el-button size="mini" type="success" @click="handleCopy(scope.row)"style="width: 100px;margin: 1px;">复制</el-button>
              <el-button size="mini" type="danger" @click="deleteData(scope.row)"style="width: 100px;margin: 1px;">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>




        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click='closeDialog("edit")':close-on-click-modal="false">
          <el-form label-width="150px" :model="editForm" ref="editForm"  :rules="rules">

            <el-form-item label="产品名称" prop="name">
              <el-input size="small"  v-model="editForm.name" style="width: 300px"  auto-complete="off" placeholder="产品模块分类"></el-input>
            </el-form-item>

            <el-form-item label="封面图" prop="coverImg">
              <el-upload
                  class="avatar-uploader"
                  :action="this.host+'/upload/file'"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccessImage"
                  :before-upload="beforeAvatarUpload">
                <img v-if="editForm.coverImg" :src="editForm.coverImg" class="avatar" width="200">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">请上传图片，建议规格：694*486</div>
              </el-upload>
            </el-form-item>


            <el-form-item label="产品系列" prop="seriesId">
              <el-select v-model="editForm.seriesId" placeholder="请选择"  style="height: 33px;width: 250px;">
                <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="产品简介" prop="remark">
              <wangeditor @catchData="catchData" class="catchData margin-top" ref="child"></wangeditor>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
              <el-input-number :min="0" oninput="if (value < 0) value= null" placeholder="排序" v-model="editForm.sort" style="width: 250px"></el-input-number>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title" :loading="loading" :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>



        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisibleFz" width="60%" @click='closeDialog("edit")':close-on-click-modal="false">
          <el-form label-width="150px" :model="editForm" ref="editForm"  :rules="rules">

            <el-form-item label="产品名称" prop="name">
              <el-input size="small"  v-model="editForm.name" style="width: 300px"  auto-complete="off" placeholder="产品模块分类"></el-input>
            </el-form-item>

            <el-form-item label="封面图" prop="coverImg">
              <el-upload
                  class="avatar-uploader"
                  :action="this.host+'/upload/file'"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccessImage"
                  :before-upload="beforeAvatarUpload">
                <img v-if="editForm.coverImg" :src="editForm.coverImg" class="avatar" width="200">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">请上传图片，建议规格：694*486</div>
              </el-upload>
            </el-form-item>


            <el-form-item label="产品系列" prop="seriesId">
              <el-select v-model="editForm.seriesId" placeholder="请选择"  style="height: 33px;width: 250px;">
                <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="产品简介" prop="remark">
              <wangeditor @catchData="catchData" class="catchData margin-top" ref="child"></wangeditor>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
              <el-input-number :min="0" oninput="if (value < 0) value= null" placeholder="排序" v-model="editForm.sort" style="width: 250px"></el-input-number>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title" :loading="loading" :disabled="isDisabled" @click="submitFormFz('editForm')">保存</el-button>
          </div>
        </el-dialog>




      </el-main>
    </el-container>
  </div>
</template>

<script>


import {qryInfo, addInfo,addInfoPl, upInfo, delInfo, delInfoPl, qrySeries} from '../../api/productApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import wangeditor from "../../components/wangeditor";
var cateDate = [];

export default {
  name: "userList",
  filters:{
    getCate(v){
      var name = '';
      cateDate.forEach((item,index)=>{
        if(item.id == v) name = item.name
      })
      return name
    },
  },

  data() {
    return {
      title:'修改',
      editFormVisible:false,
      editFormVisibleFz:false,
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        name:'',
        seriesId:'',
        page:1,
        pageSize:10
      },
      listData:[],
      cateList:[],
      multipleSelection:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      editForm:{
        id:'',
        name:'',
        mid:'',
        coverImg:'',
        seriesId:'',
        remark:'',
        sort:'',
      },
      // rules表单验证
      rules: {
        coverImg: [
          { required: true, message: '必填字段不能为空', trigger: 'blur' }
        ],
        seriesId: [
          { required: true, message: '必填字段不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '必填字段不能为空', trigger: 'blur' }
        ],
      },

    }
  },
  mounted() {
    this.tableList();
    this.qryxl();
  },
  methods:{
    tableList(e){
      if (e == 1){
        this.formInline.page = 1
      }
      this.loading = true;
      qryInfo(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })
    },


    qryxl(){
      qrySeries({pageSize:1000}).then(res => {
        this.cateList = res.data.list;
        cateDate = res.data.list;
      })
    },

    resetFrom(){
      this.formInline.name = '';
      this.formInline.seriesId = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },


    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },



    //显示编辑界面
    handleEdit: function(row) {
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.name = row.name
        this.editForm.coverImg = row.coverImg
        this.editForm.seriesId = row.seriesId
        this.editForm.remark = row.remark
        this.editForm.sort = row.sort

        let _this = this;
        setTimeout(() => {
          _this.$refs.child.echo(this.editForm.remark);
        }, 0)

        this.editFormVisible = true
      } else {
        this.title = '添加'
        this.editFormVisible = true
        this.clear()
      }
    },

    handleCopy(row){

      this.title = '复制'
      this.editForm.id = ''
      this.editForm.mid = row.id
      this.editForm.name = row.name
      this.editForm.coverImg = row.coverImg
      this.editForm.seriesId = row.seriesId
      this.editForm.remark = row.remark
      this.editForm.sort = row.sort

      let _this = this;
      setTimeout(() => {
        _this.$refs.child.echo(this.editForm.remark);
      }, 0)

      this.editFormVisibleFz = true
    },


    clear(){
      this.editForm.id = ''
      this.editForm.name = '';
      this.editForm.coverImg = ''
      this.editForm.seriesId = ''
      this.editForm.remark = ''
      let _this = this;
      setTimeout(() => {
        _this.$refs.child.echo(this.editForm.remark);
      }, 0)
      this.editForm.sort = ''
    },





    closeDialog(editData){
      this.$refs['editForm'].resetFields();
      this.editFormVisible = false;
      this.editFormVisibleFz = false;
      this.clear();
    },



    // 编辑、添加提交方法
    submitForm(editData) {
      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!=''){
            upInfo(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisible = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.tableList()
                this.clear()
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisible = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }
          else{
            addInfo(this.editForm)
                .then(res => {
                  if (res.code==1) {
                    this.editFormVisible = false
                    this.$message({
                      type: 'success',
                      message: '数据保存成功！'
                    })
                    this.tableList(this.formInline)
                    this.clear()
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                  this.isDisabled = false;
                })
                .catch(err => {
                  this.editFormVisible = false
                  this.$message.error('保存失败，请稍后再试！')
                  this.isDisabled = false;
                })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },



    submitFormFz(editData) {
      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          addInfoPl(this.editForm)
              .then(res => {
                if (res.code==1) {
                  this.editFormVisibleFz = false
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.tableList(this.formInline)
                  this.clear()
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.editFormVisibleFz = false
                this.$message.error('保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },



    deleteData(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delInfo(row)
            .then(res => {
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据已更新!'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },

    handleSelectionChangeDel(val){
      this.multipleSelection = val;
    },



    handlePlDel() {
      if (this.multipleSelection.length === 0){
        this.$message.error('请选择数据！')
        return
      }
      this.isDisabled = true;
      var data = {
        ids:this.multipleSelection.map(element=>element.id)
      }
      this.$refs.tabs.clearSelection();
      delInfoPl(data).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList();
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
        this.isDisabled = false;
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
        this.isDisabled = false;
      })
    },
    handleAvatarSuccessImage(res) {
      this.editForm.coverImg = res.data;
    },


    beforeAvatarUpload(file) {
      //const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 10;

      /*if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }*/
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return isLt2M;
    },



    catchData(val){
      this.editForm.remark = val;
    },

  },
  //分页组件
  components: {
    ElInputNumber,
    wangeditor,
    Pagination
  }
}



</script>



<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/product/info.vue